import axios from "axios";
import { GetPlayersProps, SinglePlayer } from "./models";
import { getConfig } from "../../../../ApiHelpers/ApiDefaultConfig";

const getPlayers = async ({ page, pageSize, startDate, endDate, createdInPromo, platformUser, download, hasPhone }: GetPlayersProps): Promise<any> => {
    let config = getConfig();
    try {
        const createQueryParams = new URLSearchParams();

        if (page) createQueryParams.set('page', page.toString());
        if (pageSize) createQueryParams.set('pageSize', pageSize.toString());
        if (startDate) createQueryParams.set('startDate', startDate);
        if (endDate) createQueryParams.set('endDate', endDate);
        if (createdInPromo) createQueryParams.set('createdInPromo', createdInPromo.toString());
        if (platformUser) createQueryParams.set('platformUser', platformUser);
        if (download) createQueryParams.set('download', download.toString());
        if (hasPhone) createQueryParams.set('hasPhone', hasPhone.toString());

        const response = await axios.get<any>(`/players-dashboard/players?${createQueryParams.toString()}`, config);
        return response.data;

    } catch (error) {
        return error as any;
    }
};

const patchPlayer = async (player: Partial<SinglePlayer>) => {
    let config = getConfig();
    try {
        const response = await axios.patch(`/players-dashboard/updatePlayer?playerId=${player.id}`, player, config);
        return response.data;
    } catch (error) {
        return error as any;
    }
}


const createPlayer = async (player: Partial<SinglePlayer>) => {
    let config = getConfig();
    try {
        const response = await axios.post(`/players-dashboard/createPlayer`, player, config);
        return response.data;
    } catch (error) {
        return error as any;
    }
}

export const checkPlayerExists = async (platformUser: string) => {
    let config = getConfig();
    try {
        const response = await axios.get(`/players-dashboard/checkPlayerExists?platformUser=${platformUser}`, config);
        return response.data;
    } catch (error) {
        return error as any;
    }
}

export { getPlayers, patchPlayer, createPlayer };